// Joins the truthy class names, as the prototype's ui.jsx does.
export const cx = (...classes) => classes.filter(Boolean).join(" ");
